<div class="outer-wrapper">
  <!-- HANDLE TAXONOMY-SETTINGS SIGNAL-->
  @if (true) {
  <!-- HTML -->
  <div class="wrapper">
    <!-- Tab selection commented out - Entities tab always selected -->
    <!-- <div class="tab-selection">
      <div class="tab-buttons">
        <button [class.active]="selectedTabIndex === 0" (click)="onTabChange(0)">
          Entities Hub
        </button>
        <button [class.active]="selectedTabIndex === 1" (click)="onTabChange(1)">
          Playground
        </button>
      </div>
    </div> -->

    <div class="selected-area">
      <!-- Entities tab always selected -->
      <ng-container *ngIf="selectedTabIndex === 0">
        <app-taxonomy-entity-hub-v2></app-taxonomy-entity-hub-v2>
      </ng-container>
      <!-- Playground tab commented out -->
      <!-- <ng-container *ngIf="selectedTabIndex === 1">
        <app-taxonomy-playground></app-taxonomy-playground>
      </ng-container> -->
    </div>
  </div>


  } @else{
  <!-- IF SIGNAL IS TRUE THEN OPEN WRAPPER -->
  <app-taxonomy-settings></app-taxonomy-settings>
  }
</div>
